import { useEffect, useState } from "react"
import { OtpSend } from "../../../apis/auth"
import { aggrementVerify } from "../../../apis/loans"

const AadharVerify = ({
    type,
    loanId,
    isAlreadyVerified,
    defaultAadhar,
    onVerified }) => {

    const [aadharNo, setAadharNo] = useState(defaultAadhar || "")
    const [isOtpSent, setIsOtpSent] = useState(true)
    const [countdown, setCountdown] = useState(0)
    const [aadharRef, setAadharRef] = useState("")
    const [openOtp, setOpenOtp] = useState(false)
    const [otp, setOtp] = useState()
    const mtIdString = sessionStorage.getItem("info")
    const userData = JSON.parse(mtIdString);

    useEffect(() => {
        if (!isOtpSent || countdown <= 0) return
        const timer = setInterval(() => {
            setCountdown(prev => prev - 1)
        }, 1000)
        return () => clearInterval(timer)
    }, [isOtpSent, countdown])

    useEffect(() => {
        if (defaultAadhar) {
            setAadharNo(defaultAadhar);
        }
    }, [defaultAadhar]);

    const formatCountdown = seconds => {
        const minutes = String(Math.floor(seconds / 60)).padStart(2, "0")
        const secs = String(seconds % 60).padStart(2, "0")
        return `${minutes}:${secs}`
    }

    let mtId = null
    if (mtIdString) {
        try {
            mtId = JSON.parse(mtIdString)
        } catch (error) {
            console.error("Failed to parse sessionStorage info:", error)
        }
    }


    const sendAadharOtp = async e => {

        e.preventDefault()
        const payload = {
            aadharNumber: aadharNo,
            user_id: userData?.user_id,
            user_type: userData?.type,
            user_name: userData?.username
        }
        const response = await OtpSend(payload)
        setAadharRef(response.data.reference_id)
        setOpenOtp(true)
        setCountdown(300)
    }

    const reSendAadharOtp = async e => {
        e.preventDefault()
        const payload = {
            aadharNumber: aadharNo,
            user_id: userData?.user_id,
            user_type: userData?.type,
            user_name: userData?.username
        }
        await OtpSend(payload)
        setOpenOtp(true)
        alert("OTP is resent successfully!")
    }

    const verifyAadhar = async e => {
        e.preventDefault()
        const payload = {
            aadharNumber: aadharNo,
            otp: otp,
            ref_id: aadharRef,
            type,
            loanId,
            user_id: userData?.user_id,
            user_type: userData?.type,
            user_name: userData?.username,
        }
        const response = await aggrementVerify(payload)
        const { data } = response
        setOpenOtp(false)
        onVerified(true)
    }

    if (isAlreadyVerified) {
        return (
            <div className="text-success fw-bold">
                ✅ Aadhaar Verified
            </div>
        );
    }

    return (
        <>
            <div className="d-flex justify-content-center" style={styles.container}>
                <form>
                    <div
                        className="tab-pane fade show active"
                        id="basic-info"
                        role="tabpanel"
                        aria-labelledby="info-tab"
                        tabIndex={0}
                    >
                        <div className="modal-body pb-0 mt-20">
                            <div className="row">
                                <div className="">
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Aadhar Number{" "}
                                            <span className="text-danger"> *</span>
                                        </label>
                                        <input
                                            type="text"
                                            value={aadharNo}
                                            maxLength={12}
                                            onChange={e => setAadharNo(e.target.value)}
                                            className="form-control"
                                            disabled
                                        />
                                    </div>
                                </div>
                                {openOtp && (
                                    <div className="">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Aadhar Otp
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <input
                                                type="number"
                                                value={otp}
                                                onChange={e => setOtp(e.target.value)}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            {!openOtp ? (
                                <button
                                    type="submit"
                                    onClick={sendAadharOtp}
                                    className="btn btn-primary"
                                >
                                    Send Otp
                                </button>
                            ) : (
                                <div>
                                    {countdown > 0 ? (
                                        <span className="text-muted me-3">
                                            Resend available in {formatCountdown(countdown)}
                                        </span>
                                    ) : (
                                        <button
                                            type="submit"
                                            onClick={reSendAadharOtp}
                                            className="btn btn-primary me-2"
                                        >
                                            Resend OTP
                                        </button>
                                    )}
                                    <button
                                        type="submit"
                                        onClick={verifyAadhar}
                                        className="btn btn-primary"
                                    >
                                        Verify Otp
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}

const styles = {
    container: {
        backgroundColor: "#f8f9fa",
        padding: "10px",
        borderRadius: "8px",
        border: "1px solid #dee2e6",
        width: "300px",
    },

};

export default AadharVerify
